<template>
    <div>
         <div class="d-flex flex-wrap">
            <div class="card mr-3">
                <div class="card-body">
                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-shopping-cart"></i></span>
                    <h6 class="mb-0 font-weight-semibold">{{ $t("Waiting for transfer") }}</h6>
                    <h3 class="text-grey-800 font-weight-semibold my-1">฿{{amountPending | formatNumber}}</h3>
                     <span class="mr-1" :class="[percentageTransfer < 0 ? 'text-danger' : 'text-green-custom',]">
                        <i class="fas mr-1" :class="percentageTransfer < 0 ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                        {{percentageTransfer | formatNumber}}%
                    </span> <span class="text-grey-300">{{$t('compared to last month')}}</span>
                </div>
            </div>

            <div class="card mr-3">
                <div class="card-body">
                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i style="font-size: 11px;" class="fa-solid fa-sack-dollar"></i></span>
                    <h6 class="mb-0 font-weight-semibold">{{$t('Money transferred')}}</h6>
                    <h3 class="text-grey-800 font-weight-semibold my-1">฿{{amountTransfer | formatNumber}}</h3>
                     <span class="mr-1" :class="[percentagePending < 0 ? 'text-danger' : 'text-green-custom',]">
                        <i class="fas mr-1" :class="percentagePending < 0 ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                        {{percentagePending | formatNumber}}%
                    </span> <span class="text-grey-300">{{$t('compared to last month')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import numeral from "numeral";
    import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
    import VueJsCounter from "@/plugins/VueJsCounter";
    import Api from "@/services/endpoint/tenant.service.js";
    import moment from "moment";
    import {
        convertTimezone
    } from "@/common/tenancy/convertTimezone";
    export default {
        name: "tabcodoverviews",
        components: {
            //numeral,
            PlaceholderContent,
            VueJsCounter,
        },
        props:['startDate','endDate'],
        data: function () {
            return {
                isLoaded: true,
                percentageTransfer: 0,
                percentagePending: 0,
                since_text: "Since last month",
                duration: 2000,
                amountTransfer:0,
                amountPending:0,
                paramsQuery: {
                    start_date: this.startDate,
                    end_date: this.endDate,
                },
            }
        },
        methods: {
            async overViewsAll(){
                try {
                    let queryString = '';
                   
                    this.paramsQuery.start_date = moment(this.startDate).format('YYYY-MM-DD') + " 00:00:00";
                    this.paramsQuery.end_date = moment(this.endDate).format('YYYY-MM-DD') + " 23:59:59";
                    if (this.paramsQuery) {
                        queryString += '?' + $.param(this.paramsQuery);
                    }

                    let response =  await Api.Report.getCodOverViews(queryString);

                    this.amountTransfer = response.transfer;
                    this.amountPending = response.pending;

                    this.percentageTransfer = response.reconcileTransferLastMonth ;
                    this.percentagePending = response.reconcilePendingLastMonth;
                }
                catch(error) {
                    if (error.response.status == 403) {
                        this.$parent.hasPermission = true;
                        this.$parent.onload = false;
                    } else {
                        this.$router.push({name: "t.a.home"});
                        console.log(error.response, 'error');
                    }
                }
            }
        },
         filters: {
            formatNumber: function (value) {
                if (value == '-') {
                    value = 0;
                }
                return numeral(value).format("0,0.00");
            },
        },
        watch:{
            startDate(){
                this.overViewsAll();
            },
            endDate(){
                this.overViewsAll();
            }
        },
        mounted() {
            this.overViewsAll();
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/TabCodOverViews.vue